import { Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanMatch {
  constructor(private router: Router) {}

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    if (localStorage.getItem('accessToken')) return true;

    const target = '/' + segments.map((s) => s.path).join('/');
    return this.router.createUrlTree(['/access/login'], {
      queryParams: { redirect: target || '/dashboard' },
    });
  }
}
